const cookies = [
  {
    name: "__gsas",
    purposes: "Advertising",
    products: "AdSense for Search",
    lifespan: "3 months",
    domain: "Set from partner domain",
  },
  {
    name: "__eoi",
    purposes: "Security",
    products: "AdSense, AdSense for Search, Display & Video 360, Google Ad Manager, Google Ads",
    lifespan: "6 months",
    domain: "Set from partner domain",
  },
  {
    name: "__gpi",
    purposes: "Advertising",
    products: "AdSense, Google Ad Manager",
    lifespan: "13 months",
    domain: "Set from partner domain",
  },
  {
    name: "__gpi_optout",
    purposes: "Advertising",
    products: "AdSense, Google Ad Manager",
    lifespan: "13 months",
    domain: "Set from partner domain",
  },
  {
    name: "NID",
    purposes: "Security, Analytics, Functionality, Advertising",
    products: "AdSense for Search, Google Ads",
    lifespan: "6 months",
    domain: "google.com and local variations, e.g. google.de",
  },
  {
    name: "DSID",
    purposes: "Security, Functionality, Advertising",
    products:
      "AdSense, Campaign Manager, Google Ad Manager, Google Analytics, Display & Video 360, Search Ads 360",
    lifespan: "2 weeks",
    domain: "doubleclick.net",
  },
  {
    name: "test_cookie",
    purposes: "Functionality",
    products:
      "AdSense, Campaign Manager, Google Ad Manager, Google Analytics, Display & Video 360, Search Ads 360",
    lifespan: "15 minutes",
    domain: "doubleclick.net",
  },
  {
    name: "id",
    purposes: "Functionality, Advertising",
    products: "AdSense, Campaign Manager, Display & Video 360, Google Ad Manager, Search Ads 360",
    lifespan:
      "OPT_OUT: fixed expiration (year 2030/11/09), non-OPT_OUT: 13 months EEA UK / 24 months elsewhere",
    domain: "doubleclick.net",
  },
  {
    name: "__gads",
    purposes: "Advertising",
    products: "AdSense, Display & Video 360, Google Ad Manager, Google Ads",
    lifespan: "13 months",
    domain: "Set from partner domain",
  },
  {
    name: "GED_PLAYLIST_ACTIVITY",
    purposes: "Advertising",
    products: "AdSense, Google Ad Manager, YouTube",
    lifespan: "Session",
    domain: "Set from partner domain",
  },
  {
    name: "ACLK_DATA",
    purposes: "Advertising",
    products: "AdSense, Google Ad Manager, YouTube",
    lifespan: "5 minutes",
    domain: "youtube.com",
  },
  {
    name: "receive-cookie-deprecation",
    purposes: "Security, Advertising",
    products: "Campaign Manager, Display & Video 360",
    lifespan: "6 months",
    domain: "doubleclick.net",
  },
  {
    name: "pm_sess",
    purposes: "Security, Functionality",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "30 minutes",
    domain: "doubleclick.net, google.com",
  },
  {
    name: "pm_sess_NNN",
    purposes: "Security, Functionality",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "30 minutes",
    domain: "doubleclick.net, google.com",
  },
  {
    name: "aboutads_sessNNN",
    purposes: "Security, Functionality",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "30 minutes",
    domain: "doubleclick.net, google.com",
  },
  {
    name: "FPAU",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "ANID*",
    purposes: "Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "13 months EEA UK / 24 months elsewhere",
    domain: "google.com and local variations, e.g. google.de",
  },
  {
    name: "AID*",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "13 months EEA UK / 540 days elsewhere",
    domain: "google.com/ads, google.com/ads/measurement, googleadservices.com",
  },
  {
    name: "ar_debug",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Google Analytics, Search Ads 360",
    lifespan: "90 days",
    domain: "googleadservices.com, google-analytics.com, doubleclick.net",
  },
  {
    name: "IDE",
    purposes: "Advertising",
    products:
      "Campaign Manager, Display & Video 360, Google Ad Manager, Google Analytics, Search Ads 360",
    lifespan: "13 months EEA UK / 24 months elsewhere",
    domain: "doubleclick.net",
  },
  {
    name: "TAID*",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "14 days",
    domain: "google.com/ads, google.com/ads/measurement, googleadservices.com",
  },
  {
    name: "FPGCLDC",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Search Ads 360",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_dc",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Search Ads 360",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_au",
    purposes: "Analytics, Advertising",
    products: "Campaign Manager, Display & Video 360, Google Ads, Search Ads 360",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "FLC",
    purposes: "Advertising",
    products: "Campaign Manager, Display & Video 360, Search Ads 360",
    lifespan: "10 seconds",
    domain: "doubleclick.net",
  },
  {
    name: "RUL",
    purposes: "Advertising",
    products: "Display & Video 360, Google Ads",
    lifespan: "12 months",
    domain: "doubleclick.net",
  },
  {
    name: "FCCDCF",
    purposes: "Functionality",
    products: "Funding Choices",
    lifespan: "13 months",
    domain: "Set from partner domain",
  },
  {
    name: "FCNEC",
    purposes: "Analytics",
    products: "Funding Choices",
    lifespan: "365 days",
    domain: "Set from partner domain",
  },
  {
    name: "FPGCLAW",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "FPGCLGB",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "FPGSID",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_gb",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gac_gb_<wpid>",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_aw",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "GCL_AW_P",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_gs",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_ag",
    purposes: "Analytics, Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "1P_JAR*",
    purposes: "Advertising",
    products: "Google Ads",
    lifespan: "30 days",
    domain: "google.com and local variations, e.g. google.de",
  },
  {
    name: "Conversion",
    purposes: "Advertising",
    products: "Google Ads",
    lifespan: "90 days",
    domain: "www.googleadservices.com/pagead/conversion/",
  },
  {
    name: "YSC",
    purposes: "Security",
    products: "Google Ads, YouTube",
    lifespan: "Session",
    domain: "youtube.com",
  },
  {
    name: "VISITOR_INFO1_LIVE",
    purposes: "Security, Advertising",
    products: "Google Ads, YouTube",
    lifespan: "180 days",
    domain: "youtube.com",
  },
  {
    name: "VISITOR_INFO1_LIVE__k",
    purposes: "Security, Advertising",
    products: "Google Ads, YouTube",
    lifespan: "180 days",
    domain: "youtube.com",
  },
  {
    name: "VISITOR_INFO1_LIVE__default",
    purposes: "Security, Advertising",
    products: "Google Ads, YouTube",
    lifespan: "180 days",
    domain: "youtube.com",
  },
  {
    name: "FPLC",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "20 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_ga",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "2 years",
    domain: "Set from partner domain",
  },
  {
    name: "_gac_<wpid>",
    purposes: "Advertising",
    products: "Google Analytics",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gid",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_gat[_<customname>]",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "1 minute",
    domain: "Set from partner domain",
  },
  {
    name: "__utma",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "2 years",
    domain: "Set from partner domain",
  },
  {
    name: "__utmb",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "30 minutes",
    domain: "Set from partner domain",
  },
  {
    name: "__utmc",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "Session",
    domain: "Set from partner domain",
  },
  {
    name: "__utmt",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "10 minutes",
    domain: "Set from partner domain",
  },
  {
    name: "__utmz",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "6 months",
    domain: "Set from partner domain",
  },
  {
    name: "__utmv",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "2 years",
    domain: "Set from partner domain",
  },
  {
    name: "AMP_TOKEN",
    purposes: "Functionality",
    products: "Google Analytics",
    lifespan: "30 seconds to 1 year",
    domain: "Set from partner domain",
  },
  {
    name: "FPID",
    purposes: "Analytics",
    products: "Google Analytics",
    lifespan: "2 years",
    domain: "Set from partner domain",
  },
  {
    name: "GA_OPT_OUT",
    purposes: "Functionality",
    products: "Google Analytics",
    lifespan: "10 Nov 2030 (all cookies)",
    domain: "google-analytics.com",
  },
  {
    name: "_ga_<wpid>",
    purposes: "Analytics",
    products: "Google Analytics 360",
    lifespan: "2 years",
    domain: "Set from partner domain",
  },
  {
    name: "_dc_gtm_<property-id>",
    purposes: "Analytics",
    products: "Google Analytics, Google Tag Manager",
    lifespan: "1 minute",
    domain: "Set from partner domain",
  },
  {
    name: "_gaexp",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "Set by customer; max of 93 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gaexp_rc",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "10 seconds",
    domain: "Set from partner domain",
  },
  {
    name: "_opt_awcid",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_opt_awmid",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_opt_awgid",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_opt_awkid",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_opt_utmc",
    purposes: "Analytics",
    products: "Google Analytics, Optimize",
    lifespan: "24 hours",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_gf",
    purposes: "Analytics, Advertising",
    products: "Google Flights",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "_gcl_ha",
    purposes: "Analytics, Advertising",
    products: "Google Hotel Ads",
    lifespan: "90 days",
    domain: "Set from partner domain",
  },
  {
    name: "PAIDCONTENT",
    purposes: "Analytics, Advertising",
    products: "Google Surveys",
    lifespan: "30 days",
    domain: "doubleclick.net",
  },
  {
    name: "_opt_expid",
    purposes: "Analytics",
    products: "Optimize",
    lifespan: "10 seconds",
    domain: "Set from partner domain",
  },
  {
    name: "APC",
    purposes: "Advertising, Security",
    products: "Campaign Manager, Display & Video 360",
    lifespan: "6 months",
    domain: "doubleclick.net",
  },
];

export default cookies;
